import { defaultSimpleStructuralRiskBandsConfig } from "@/features/risk_bands";
import portfolioExport from "@/tools/aggregate/portfolio-export";
import { allTools } from "@/tools/all_tools";
import gdcr from "@/tools/market-intelligence/gdcr";
import largeSiteScreenTool from "@/tools/risk-bands/large-site-screen";
import { HubThemePartial } from "../../types";
import { XdiHomeDashboard } from "./components/XdiHomeDashboard";

const xdiThemeBase: HubThemePartial = {
  meta: {
    name: "XDI Climate Risk Hub",
    hasFontStyles: true,
    config: {
      featureSet: {
        comms: {
          support: {
            enabled: true,
            url: "/contact/support",
          },
          feedback: {
            enabled: true,
            url: "/contact/feedback",
          },
          reseller: {
            ticketRequestForm: {
              enabled: true,
            },
          },
        },
        docs: {
          contextualElementTutorials: {
            enabled: true,
          },
          knowledgeBase: {
            glossary: {
              enabled: true,
            },
            archetypes: {
              enabled: true,
            },
            modelling: {
              enabled: true,
              publicDocsUrl: "https://learn.xdi.systems/docs/climate-and-hazard-modelling ",
            },
            changeLog: {
              enabled: true,
            },
            faqs: {
              enabled: true,
            },
          },
          toolPageTutorials: {
            enabled: true,
          },
        },
        settings: {
          enabled: true,
        },
        tools: [
          ...allTools.filter(({ keyPrefix }) => keyPrefix !== "comprehensive.blaze"),
          {
            ...portfolioExport,
            hasTutorial: true,
          },
          largeSiteScreenTool,
          gdcr,
        ],
        tracking: {
          hubspot: {
            enabled: true,
            allowEmbedCode: false,
            allowToolTracking: true,
            pipeline: {
              id: "49578663", // "Hub Usage Pipeline"
              stage: "101746048", // "Hub Analysis Done (Hub Usage Pipeline)""
            },
          },
          plausible: {
            enabled: true,
            allowLocalTracking: false,
            siteDomain: "app.climaterisk.net",
          },
        },
        widgets: {
          allowDocument360Widget: true,
        },
      },
      locale: {
        defaultLanguage: "en-AU",
      },
      pages: {
        collections: {
          enabled: true,
        },
        home: XdiHomeDashboard,
      },
      riskBands: defaultSimpleStructuralRiskBandsConfig,
      portfolioExport: {
        largeBank: {
          minAddresses: 20,
        },
        visualization: {
          portfolioLevel: {
            enabled: true,
          },
          pointLevel: {
            enabled: true,
          },
        },
      },
    },
    logoUrl: "/xdi-logo.png",
    logoIconUrl: "/xdi-logo-icon.png",
    backgroundImage: "/xdi-background.svg",
    backgroundColor: "#454545",
  },
  antd: {
    token: {
      fontFamily:
        "'Figtree',-apple-system,BlinkMacSystemFont,'Segoe UI Adjusted','Segoe UI','Liberation Sans',sans-serif",
      colorPrimary: "#D92028",
      colorText: "var(--color-gray-700)",
      colorTextSecondary: "var(--color-gray-400)",
      colorTextTertiary: "var(--color-gray-400)",
    },
    components: {
      Layout: {
        headerBg: "var(--color-gray-50)",
      },
      Splitter: {
        controlItemBgActiveHover: "#D92028",
        controlItemBgActive: "#D92028",
        splitBarSize: 3,
      },
    },
  },
};

export default xdiThemeBase;
